import { render, staticRenderFns } from "./Warning-Bar.vue?vue&type=template&id=dc2e8388&scoped=true&"
import script from "./Warning-Bar.vue?vue&type=script&lang=js&"
export * from "./Warning-Bar.vue?vue&type=script&lang=js&"
import style0 from "./Warning-Bar.vue?vue&type=style&index=0&id=dc2e8388&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2e8388",
  null
  
)

export default component.exports